// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link-error[data-v-2b65ef0d] {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.link-error .icon[data-v-2b65ef0d] {\n  position: relative;\n}\n.link-error .icon img[data-v-2b65ef0d] {\n  width: 150px;\n  margin: 0 auto;\n  display: table;\n}\n.link-error h1[data-v-2b65ef0d] {\n  margin-top: 0.5em;\n  font-size: 1.4em;\n  font-weight: 600;\n  color: #3084ec;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
